<app-si-dialog header="InboxIntel Settings">
    <ng-template appDialogBody>
        <div class="p-6">
            <div class="rounded-md border border-success bg-light text-dark px-4 py-3 text-sm" role="alert">
                <fa-icon aria-hidden="true" [icon]="['fas', 'circle-info']"></fa-icon> You have authorized InboxIntel to scan your email inbox at {{oAuthUserId}}
            </div>
            <p class="mb-6">Deauthorize InboxIntel from scanning your email inbox.</p>
            <p class="mb-6">If you want to stop using InboxIntel, you may deauthorize it to remove the
                permission to access your email inbox. To start using InboxIntel again, you will need to authorize it
                again using your email account.
            </p>
        </div>
    </ng-template>

    <ng-template appDialogFooter>
        <button matButton="filled" class="mat-small-button mat-error" [disabled]="isLoading$ | async" (click)="deauthorize()">Deauthorize InboxIntel</button>
    </ng-template>
</app-si-dialog>
